import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user', 'userIsPatient', 'userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/computed.js